// =====================================================================
// Tokens visuais do CALENDÁRIO (as 4 camadas + o vestido dos modais)
// =====================================================================
// Compartilhados pelas duas telas que desenham calendário:
//   - /aniversariantes (CalendarioAniversariantes) — tela cheia, dona do CRUD
//     de feriados e eventos;
//   - o modal do ícone de calendário (CalendarioAgenda) — as mesmas camadas
//     mais os compromissos do Teams.
// Se a cor de uma camada morasse em cada tela, uma mudaria e a outra não — foi
// o que quase aconteceu quando o feriado virou amarelo (era azul nas duas).

import { COR, FONTE } from './ui';

// ---------------------------------------------------------------------
// CAMADA — a identidade visual de cada tipo de item do calendário.
// ---------------------------------------------------------------------
// `cor` é o TEXTO da tag (e a borda do quadradinho da legenda); `fundo` é a
// pastilha atrás dele. Os pares foram escolhidos por CONTRASTE — texto de tag
// tem 11px, então cor clara sobre fundo claro fica ilegível. Em especial:
// o feriado é "amarelo", mas o texto usa um âmbar ESCURO (#a16207): o amarelo
// da marca (#FDBB20) sobre o creme (#FEF3D4) dá ~1,6:1 de contraste e some.
export const CAMADA = {
    // Roxo: cor da marca Teams e a única das quatro que o usuário edita aqui.
    teams: { cor: '#4f46e5', fundo: '#e8e7fd', rotulo: 'Compromisso (Teams)' },
    // Amarelo da marca no fundo, âmbar escuro no texto (ver nota acima).
    feriado: { cor: '#a16207', fundo: COR.amareloFundo, rotulo: 'Feriado' },
    evento: { cor: '#0f766e', fundo: '#ccfbf1', rotulo: 'Evento' },
    aniversario: { cor: COR.vermelhoEscuro, fundo: COR.iconeFundo, rotulo: 'Aniversário' },
};

// Quem pode cadastrar/remover FERIADO. Espelha o authorizeRoles do backend
// (server/home/server-calendario.js › PERFIS_GESTAO): esconder o botão para os
// demais evita oferecer uma ação que voltaria 403. Evento, qualquer logado cria.
export const PERFIS_GESTAO_FERIADO = ['Admin', 'Marketing'];

export const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem('authToken')}` });

export const MESES = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];

// ---------------------------------------------------------------------
// Vestido compartilhado dos modais do calendário (feriados, evento, detalhe).
// ---------------------------------------------------------------------
// zIndex 1100: acima do modal do calendário (950, no BotaoAgenda) — estes são
// abertos DE DENTRO dele e precisam empilhar por cima.
export const modalOverlay = { position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.45)', zIndex: 1100, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' };
export const modalCard = { backgroundColor: '#fff', borderRadius: '12px', boxShadow: '0 4px 8px rgba(0,0,0,0.12)', width: '460px', maxWidth: '100%', maxHeight: '85vh', overflowY: 'auto', fontFamily: FONTE };
export const modalHeader = { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 18px', borderBottom: `1px solid ${COR.bordaSuave}` };
export const btnX = { background: 'none', border: 'none', cursor: 'pointer', color: '#999', display: 'flex' };
export const rotuloStyle = { display: 'flex', flexDirection: 'column', gap: '4px', fontSize: '12px', fontWeight: 600, color: '#555' };
export const inputStyle = { width: '100%', boxSizing: 'border-box', padding: '8px 10px', borderRadius: '8px', border: `1px solid ${COR.bordaSuave}`, fontFamily: FONTE, fontSize: '13px', outline: 'none' };
